// Custom Scripts

// playVideo
/**
 * Handles video thumbnail click events and autoplay functionality
 * @returns {void}
 */
const playVideo = () => {
  const videoLinks = document.querySelectorAll(".video-thumbnail__link");
  videoLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.add("play-video");
      const iframe = this.nextElementSibling.querySelector("iframe");
      let src = iframe.getAttribute("src");
      iframe.setAttribute("src", src + "?&autoplay=1");
    });
  });

  const closeIcons = document.querySelectorAll(".video-thumbnail__close-icon");
  closeIcons.forEach((icon) => {
    icon.addEventListener("click", function (e) {
      const src = this.parentElement
        .querySelector("iframe")
        .getAttribute("src");
      this.parentElement
        .querySelector("iframe")
        .setAttribute("src", src.replace("?&autoplay=1", ""));
      document
        .querySelector(".video-thumbnail__link")
        .classList.remove("play-video");
    });
  });
};

export { playVideo };

// Multiple Accordions
/**
 * Creates an accordion menu with nested levels
 * @returns {void}
 */
const multipleAccord = () => {
  document.querySelectorAll(".accord > ul > li").forEach((item) => {
    if (item.querySelector("ul")) {
      item.classList.add("has-sub");
    }
  });

  document
    .querySelectorAll(".accord > ul > li > .toggle-first-level")
    .forEach((toggle) => {
      toggle.addEventListener("click", function () {
        this.parentElement.classList.toggle("is-active");
      });
    });

  document.querySelectorAll(".accord > ul > li ul > li").forEach((item) => {
    if (item.querySelector("ul")) {
      item.classList.add("has-sub");
    }
  });

  document.querySelectorAll(".accord > ul > li ul > li i").forEach((icon) => {
    icon.addEventListener("click", function () {
      this.parentElement.classList.toggle("is-active");
    });
  });
};

export { multipleAccord };

/**
 * Closes a form by its button ID and content ID if currently open
 * @param {string} formBtnId - The ID of the form's toggle button
 * @param {string} formContentId - The ID of the form content container
 * @returns {void}
 */
const closeForm = (formBtnId, formContentId) => {
  const btn = document.getElementById(formBtnId);
  const form = document.getElementById(formContentId);
  if (btn && form && btn.getAttribute("state") === "open") {
    btn.setAttribute("state", "closed");
    btn.textContent = "Open Form";
    form.style.display = "none";
  }
};

// Form Control
/**
 * Controls the visibility and behavior of the suggestion form
 * Manages form state, display, and smooth scrolling to form sections
 * Closes the registration form when suggestion form is opened
 * @returns {void}
 * @throws {Error} When required DOM elements are not found
 */
const formControl = () => {
  const formControlBtn = document.getElementById("form_control");
  if (!formControlBtn) return;

  formControlBtn.addEventListener("click", function () {
    const theState = this.getAttribute("state");

    if (theState === "closed") {
      closeForm("form_control2", "the_registration_form");
      this.setAttribute("state", "open");
      document.getElementById("the_suggestion_form").style.display = "block";
      this.textContent = "Close Form";

      window.scrollTo({
        top: document.getElementById("the_suggestion_form").offsetTop,
        behavior: "smooth",
      });
    }

    if (theState === "open") {
      this.setAttribute("state", "closed");
      document.getElementById("the_suggestion_form").style.display = "none";
      this.textContent = "Open Form";

      window.scrollTo({
        top: document.getElementById("the_form_intro").offsetTop,
        behavior: "smooth",
      });
    }
  });
};

export { formControl };

// Form Control 2
/**
 * Controls the visibility and behavior of the registration form
 * Manages form state, display, and smooth scrolling to form sections
 * Closes the suggestion form when registration form is opened
 * @returns {void}
 * @throws {Error} When required DOM elements are not found
 */
const formControl2 = () => {
  const formControlBtn2 = document.getElementById("form_control2");
  if (!formControlBtn2) return;

  formControlBtn2.addEventListener("click", function () {
    const theState = this.getAttribute("state");

    if (theState === "closed") {
      closeForm("form_control", "the_suggestion_form");
      this.setAttribute("state", "open");
      document.getElementById("the_registration_form").style.display = "block";
      this.textContent = "Close Form";

      window.scrollTo({
        top: document.getElementById("the_registration_form").offsetTop,
        behavior: "smooth",
      });
    }

    if (theState === "open") {
      this.setAttribute("state", "closed");
      document.getElementById("the_registration_form").style.display = "none";
      this.textContent = "Open Form";

      window.scrollTo({
        top: document.getElementById("the_form_intro").offsetTop,
        behavior: "smooth",
      });
    }
  });
};

export { formControl2 };

// Nav Hovers
/**
 * Manages hover interactions for primary navigation menu items
 * Controls submenu visibility on mouse enter and leave events
 * @returns {Function} Cleanup function to remove event listeners
 */
const navHovers = () => {
  const primaryNavItems = document.querySelectorAll("#primary_nav li");

  primaryNavItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const subMenu = this.querySelector(".sub-menu");
      if (subMenu) {
        subMenu.style.display = "block";
      }
    });

    item.addEventListener("mouseleave", function () {
      const subMenu = this.querySelector(".sub-menu");
      if (subMenu) {
        subMenu.style.display = "none";
      }
    });
  });
};

export { navHovers };

// Mobile Menu
/**
 * Initializes and manages mobile menu functionality
 * Handles menu expansion, collapse, and submenu interactions
 * Controls back-to-top button and mobile veil behavior
 * @returns {void}
 */
const mobileMenu = () => {
  const mobileExpandBtn = document.getElementById("mobile_expand");
  const mobileCloseBtn = document.getElementById("mobile_close");
  const mobileVeil = document.getElementById("mobile_veil");
  const mobileMenu = document.getElementById("mobile_menu");
  const backToTopBtn = document.getElementById("back_to_top");
  const mobileNavItems = document.querySelectorAll(
    "#mobile_primary_nav li.menu-item-has-children",
  );

  mobileExpandBtn.addEventListener("click", function () {
    this.style.display = "none";
    mobileCloseBtn.style.display = "block";
    mobileVeil.style.display = "block";
    window.scrollTo({ top: 0, behavior: "smooth" });
    mobileMenu.style.display = "block";
  });

  mobileCloseBtn.addEventListener("click", function () {
    this.style.display = "none";
    mobileMenu.style.display = "none";
    mobileVeil.style.display = "none";
    mobileExpandBtn.style.display = "block";
    setTimeout(() => {
      mobileNavItems.forEach((item) => {
        item.querySelector(".sub-menu").style.display = "none";
      });
    }, 1000);
  });

  if (backToTopBtn) {
    backToTopBtn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  mobileNavItems.forEach((item) => {
    const button = document.createElement("button");
    button.title = "touch to open sub menu";
    button.innerHTML = "&#xf0d7;";
    item.appendChild(button);

    const subMenu = item.querySelector(".sub-menu");
    button.addEventListener("click", function () {
      subMenu.style.display = "block";
    });
  });
};

export { mobileMenu };

/**
 * Initializes modal functionality for elements with data-p-open-modal attributes
 * @returns {Function} Cleanup function to remove event listeners
 */
const modals = () => {
  // Cache DOM elements
  const modalBackground = document.querySelector(".p-modal-background");
  const modalTriggers = document.querySelectorAll("[data-p-open-modal]");
  const cancelButtons = document.querySelectorAll("[data-p-cancel]");
  const modalElements = document.querySelectorAll(".p-modal");

  // Early return if required elements are missing
  if (!modalBackground) {
    console.warn("Modal background element not found");
    return;
  }

  // Store event handlers for cleanup
  const handlers = {
    openModal: new Map(),
    cancelModal: new Map(),
    clickModal: new Map(),
    backgroundClick: null,
  };

  // Handle modal opening
  const handleModalOpen = (event) => {
    event.preventDefault();
    const selector = event.currentTarget.getAttribute("data-p-open-modal");

    if (!selector) {
      console.warn("Error: data-p-open-modal attribute is empty");
      return;
    }

    const targetModal = document.querySelector(selector);
    if (!targetModal) {
      console.warn(`Error: No modal found with selector "${selector}"`);
      return;
    }

    modalBackground.classList.add("nowactive");
    document.body.classList.add("p-modal-opened");
    targetModal.classList.add("active");

    // Hide loader immediately for inline-content modals (no iframe).
    // For iframe modals, the iframe's onload handler hides the loader.
    if (!targetModal.querySelector("iframe")) {
      targetModal.querySelectorAll(".loader").forEach((l) => {
        l.style.display = "none";
      });
    }
  };

  // Handle modal closing
  const handleModalClose = (event) => {
    event.preventDefault();
    const activeModal = document.querySelector(".p-modal.active");
    if (activeModal) {
      activeModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("p-modal-opened");
    }
  };

  // Handle modal content click (prevent propagation)
  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  // Handle background click
  const handleBackgroundClick = (event) => {
    event.preventDefault();
    const openedModal = document.querySelector(".p-modal.active");

    if (openedModal?.getAttribute("data-p-close-on-outside") === "true") {
      event.stopPropagation();
      openedModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("p-modal-opened");
    }
  };

  // Add event listeners
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", handleModalOpen);
    handlers.openModal.set(trigger, handleModalOpen);
  });

  cancelButtons.forEach((button) => {
    button.addEventListener("click", handleModalClose);
    handlers.cancelModal.set(button, handleModalClose);
  });

  modalElements.forEach((modal) => {
    modal.addEventListener("click", handleModalClick);
    handlers.clickModal.set(modal, handleModalClick);
  });

  modalBackground.addEventListener("click", handleBackgroundClick);
  handlers.backgroundClick = handleBackgroundClick;

  // Return cleanup function
  return () => {
    // Remove modal trigger listeners
    modalTriggers.forEach((trigger) => {
      const handler = handlers.openModal.get(trigger);
      trigger.removeEventListener("click", handler);
    });

    // Remove cancel button listeners
    cancelButtons.forEach((button) => {
      const handler = handlers.cancelModal.get(button);
      button.removeEventListener("click", handler);
    });

    // Remove modal click listeners
    modalElements.forEach((modal) => {
      const handler = handlers.clickModal.get(modal);
      modal.removeEventListener("click", handler);
    });

    // Remove background click listener
    if (modalBackground && handlers.backgroundClick) {
      modalBackground.removeEventListener("click", handlers.backgroundClick);
    }

    // Clear handler maps
    handlers.openModal.clear();
    handlers.cancelModal.clear();
    handlers.clickModal.clear();
    handlers.backgroundClick = null;
  };
};

export { modals };

// Hash Change Scroll Buffer
const hashChangeScrollBuffer = () => {
  const adjustScroll = () => {
    const hash = window.location.hash;
    if (!hash) return;

    setTimeout(() => {
      const targetElement = document.querySelector(hash);
      if (!targetElement) return;

      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }, 1);
  };

  // Handle initial page load with hash
  if (window.location.hash) {
    adjustScroll();
  }

  // Handle hash changes
  window.addEventListener("hashchange", adjustScroll);

  // Return cleanup function
  return () => window.removeEventListener("hashchange", adjustScroll);
};

export { hashChangeScrollBuffer };
